import sc from 'styled-components';
import { BODY_FONT_FAMILY, GRAY } from './styleConstants';

import React from 'react';
export default sc.table`
  padding: 0;
  margin: 0;
  th, td {
    padding: 0;
    margin: 0;
    font-family: {BODY_FONT_FAMILY};
  }
  thead {
    border-bottom: 1px solid black;
    th, td {
      
    }
  }
  tbody > tr {
    border-bottom: 1px solid ${GRAY};
  }
`;

export const CellContainer = sc.div`
width: 100%;
min-height: ${props => props.height || '100%;'};
display: flex;
flex-wrap: nowrap;
flex-direction: column;
justify-content: center;
align-items: stretch;
align-content: center;
`;
